import { Box, Heading20 } from '@squareup/dex-ui-shared-base';
import React, { Children, FC, PropsWithChildren, isValidElement } from 'react';

interface MdxStepProps {
  title?: string;
}

const MdxStep: FC<PropsWithChildren<MdxStepProps>> = ({ title, children }) => {
  return (
    <Box margin={{ bottom: '3x' }}>
      {title && <Heading20 margin={{ bottom: '1x' }}>{title}</Heading20>}
      {children}
    </Box>
  );
};

MdxStep.displayName = 'MdxStep';

const MdxSteps: FC<PropsWithChildren> = ({ children }) => {
  let stepNumber = 0;

  return (
    <Box margin={{ vertical: '2x' }}>
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          stepNumber++;
          return (
            <Box style={{ display: 'flex', gap: '16px' }}>
              <Box
                style={{
                  flexShrink: 0,
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--color-fill-subtle)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 600,
                }}
              >
                {stepNumber}
              </Box>
              <Box style={{ flex: 1 }}>{child}</Box>
            </Box>
          );
        }
        return child;
      })}
    </Box>
  );
};

MdxSteps.displayName = 'MdxSteps';

export { MdxSteps, MdxStep };
